<div class="row mt-4 mb-2">
  <div class="col-md-11 col-sm-12 text-center">

      <button
        type="button"
        class="btn btn-outline-primary btn-sm me-1"
        (click)="onClickTab(saleSubmissionsStatusIds.IN_REVIEW)"
        [ngClass]="{
          active: submissionsTab === saleSubmissionsStatusIds.IN_REVIEW
        }"
        data-bs-toggle="tooltip"
        [attr.title]="tooltips.inReview"
      >
        In Review ({{ getInReviewCount() }})
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm me-1"
        (click)="onClickTab(saleSubmissionsStatusIds.DENIED)"
        [ngClass]="{
          active: submissionsTab === saleSubmissionsStatusIds.DENIED
        }"
        data-bs-toggle="tooltip"
        [attr.title]="tooltips.denied"
      >
        Denied ({{ getDeniedCount() }})
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm me-1"
        (click)="onClickTab(saleSubmissionsStatusIds.APPROVED)"
        [ngClass]="{
          active: submissionsTab === saleSubmissionsStatusIds.APPROVED
        }"
        data-bs-toggle="tooltip"
        [attr.title]="tooltips.approved"
      >
        Approved ({{ getApprovedCount() }})
      </button>
      <button type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="onClickTab(saleSubmissionsStatusIds.ALL)"
              [ngClass]="{ active: submissionsTab === saleSubmissionsStatusIds.ALL }"
              data-bs-toggle="tooltip"
              [attr.title]="tooltips.all">
        All ({{ getAllCount() }})
      </button>

  </div>
</div>
<div *ngIf="_tab === saleTabs.SUBMISSIONS"
     class="table-responsive data-grid sticky-header-table sticky-header-table-height-md"
     #table>
    <table mat-table
           [dataSource]="dataSource"
           class="table table-hover"
           matSort="subsort"
           infiniteScroll
           [infiniteScrollDistance]="1"
           [infiniteScrollThrottle]="20"
           [infiniteScrollContainer]="table"
           [fromRoot]="true"
           (scrolled)="onTableScroll()">

        <ng-container matColumnDef="lotNumber">
            <th mat-header-cell class="w-4-rem" *matHeaderCellDef mat-sort-header>
                {{ lotOrHipText }} <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell
                *matCellDef="let element"
                class="cursor-pointer"
                (click)="openStudyFilePopupTrigger(element, $event)">
                <div class="hip-td-box text-success">{{ element?.lotNumber }} {{ element?.lotNumberSuffix }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="vetName">
            <th mat-header-cell mat-sort-header
                class="cursor-pointer w-6-rem h6 text-dark"
                *matHeaderCellDef>
                <strong>Vet Name <i class="fa fa-sort ms-1"></i></strong>
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.vetName }}
            </td>
        </ng-container>

        <ng-container matColumnDef="data">
            <th mat-header-cell mat-sort-header
                class="cursor-pointer w-6-rem h6 text-dark"
                *matHeaderCellDef>
                <strong>Data <i class="fa fa-sort ms-1"></i></strong>
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.data }}
            </td>
        </ng-container>

        <ng-container matColumnDef="dateTime">
            <th mat-header-cell mat-sort-header
                class="cursor-pointer w-6-rem h6 text-dark"
                *matHeaderCellDef>
                <strong>Date/Time <i class="fa fa-sort ms-1"></i></strong>
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.submissionDateTime | date : "medium" }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell mat-sort-header
                class="cursor-pointer w-4-rem h6 text-dark"
                *matHeaderCellDef>
                <strong>Status <i class="fa fa-sort ms-1"></i></strong>
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="badge"
                      [ngClass]="{
            'bg-warning':
              element.statusId === saleSubmissionsStatusIds.IN_REVIEW,
            'bg-danger': element.statusId === saleSubmissionsStatusIds.DENIED,
            'bg-success': element.statusId === saleSubmissionsStatusIds.APPROVED
          }">{{ element.status }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="comment">
            <th mat-header-cell mat-sort-header
                class="cursor-pointer w-7-rem h6 text-dark"
                *matHeaderCellDef>
                <strong>Comment <i class="fa fa-sort ms-1"></i></strong>
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element.comments }}
            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell
                class="cursor-pointer w-3-rem h6 text-dark"
                *matHeaderCellDef>
                <strong>Action</strong>
            </th>
            <td mat-cell
                *matCellDef="let element"
                class="custom-dropdown-menu"
                ngbDropdown
                placement="start">
                <div *ngIf="element.statusId == saleSubmissionsStatusIds.IN_REVIEW">
                    <button type="button"
                            (click)="openStudyFilePopup(element.horseId,element.id)"
                            title="Review Submission"
                            class="btn btn-warning btn-sm">
                        Review
                    </button>
                </div>
                <!-- <div *ngIf="element.statusId == saleSubmissionsStatusIds.IN_REVIEW">
              <div
                class="dropdown-toggl cursor-pointer inline-element"
                id="action-dropdown"
                ngbDropdownToggle
              >
                <i class="fas fa-ellipsis-v"></i>
              </div>
              <div
                class="action-dropdown"
                ngbDropdownMenu
                aria-labelledby="action-dropdown"
              >
                <button ngbDropdownItem (click)="approve(element)">Approve</button>
                <button ngbDropdownItem (click)="denied(element)">Deny</button>
              </div>
            </div> -->
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns$.value;  sticky: true;"></tr>
        <tr mat-row
            *matRowDef="
        let row;
        columns: displayedColumns$.value;
        let saleIndex = index
      "
            class="border-start-0 border-end-0 pointer"></tr>
    </table>

    <div class="row" *ngIf="saleSubmissionsLoaded">
        <div class="col-md-12 text-center">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </div>
    </div>
</div>
